import React, { useState } from "react";
import {
  AssetType,
  useDeleteAssetLocationsMutation,
} from "../store/slices/mapsSlice";
import { Button } from "react-bootstrap";
import DrawLocations from "./DrawLocations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import Clusters from "../Maps/Clusters";
import { toast } from "react-toastify";
import MyMap from "../Maps/MyMap";
import PlacesSearch from "../Contacts/PlacesSearch";
import { useConfirmDialog } from "../Builder/Components/ConfirmDialogContext";

export default function AssetLocations({
  asset: selectedAsset,
  onSave,
  setLocationOverlays,
}: {
  asset: Partial<AssetType>;
  onSave?: () => void;
  setLocationOverlays: any;
}) {
  const filters = {
    Contacts: false,
    Assets: true,
    Direct: false,
    Indirect: false,
    ExcludeWithLocation: false,
    AssetUuids: [selectedAsset.Uuid || ""],
  };

  const [overlay, setOverlay] = useState({
    show: false,
    position: { x: 0, y: 0 },
    content: <></>,
  });

  const [deleteAssetLocation] = useDeleteAssetLocationsMutation();
  const confirmDialog = useConfirmDialog();

  const handleDeleteLocation = async (locationUuid: string) => {
    if (
      !(await confirmDialog(
        "Delete location",
        `Are you sure you want to delete this location?`
      ))
    ) {
      return;
    }
    if (!selectedAsset.Uuid) return;
    const response: any = await deleteAssetLocation({
      assetUuid: selectedAsset.Uuid,
      body: [locationUuid],
    });
    if (response.error) {
      console.log(response.error);
      return;
    }
    setOverlay({ ...overlay, show: false });
    toast.success("Location deleted");
  };

  return (
    <div className="h-100 d-flex flex-column">
      <div className="flex-grow-1">
        <div>
          <span className="fw-bold">Asset name:</span>
          <span className="text-secondary ms-2">{selectedAsset.Label}</span>
        </div>
        <div>
          <span className="fw-bold">Asset description:</span>
          <span className="text-secondary ms-2">
            {selectedAsset.Description}
          </span>
        </div>
        <div className="text-secondary ">Confirm the location of the asset</div>
      </div>
      <MyMap closeOverlay={() => setOverlay({ ...overlay, show: false })}>
        <Clusters
          filters={filters}
          setLoading={() => {}}
          showPopup={(cluster, e, map) => {
            setOverlay({
              show: true,
              position: { x: e.domEvent.x, y: e.domEvent.y },
              content: cluster.IsCluster ? (
                <div className="bg-white p-3 rounded-3">
                  There are {cluster.ItemCount} items in this cluster.
                </div>
              ) : (
                <div className="bg-white p-3 rounded-3">
                  <JsonCollapse json={cluster} />
                  <button
                    title="Delete asset location"
                    className="btn btn-outline-danger border-0 btn-sm"
                    onClick={() => handleDeleteLocation(cluster.Item.Uuid)}
                  >
                    Delete location <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              ),
            });
          }}
        />
        {overlay.show && (
          <div
            className="position-fixed"
            style={{
              top: overlay.position.y - 20,
              left: overlay.position.x + 20,
              zIndex: 10000,
            }}
          >
            {overlay.content}
          </div>
        )}
        <DrawLocations
          onAdd={(o) => setLocationOverlays((p: any) => [...p, o])}
        />
        <PlacesSearch
          setAddress={(a) => {
            console.log(a);
          }}
          onAdd={(o) => setLocationOverlays((p: any) => [...p, o])}
        />
      </MyMap>
      <div className="d-flex justify-content-between">
        <Button
          variant="colored"
          className="mt-3"
          onClick={(o) => {
            setLocationOverlays((p: any[]) => {
              p.forEach((o) => {
                o.setMap(null);
              });
              return [];
            });
          }}
        >
          Reset locations
        </Button>
        <Button variant="colored" className="mt-3" onClick={onSave}>
          Save locations
        </Button>
      </div>
    </div>
  );
}
